import axios from 'axios';
import appState from '../state/AppStateContainer';
import * as Sentry from "@sentry/react";

type Event = {
  event?: string,
  userIdentifier?: string,
  metadata?: object,
}

type EventWithOptions = Event & {
  options?: {
    unique?: boolean,
  }
}

export const logEvent = async (event: EventWithOptions): Promise<void> => {
  const isPublic = !appState.getHvdToken();
  try {
    const response = await axios.post(`/api/events${isPublic ? '/public' : ''}`, event);
    return response.data;
  } catch (error) {
    console.error(error);
    Sentry.captureException(error);
  }
}
